import React, { useState } from 'react'

import { useHistory, useParams } from 'react-router-dom'
import Dialog from '@material-ui/core/Dialog'
import CancelIcon from '@material-ui/icons/Cancel'
import YoorDoor1 from '../../../images/yoor_door_1.svg'

interface Props {
  sales: number
  isAggregate: boolean
  title?: string
}

export default function MoneyTransferView(props: Props) {
  let { door_id } = useParams<{
    door_id?: string
  }>()
  const { sales, isAggregate, title = '今月の売上' } = props
  const history = useHistory()
  const [open, setOpen] = useState(false)
  const historyPath = door_id === undefined ? 
    '/management/sales/history' : 
    `/door/${door_id}/management/sales/history`
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <React.Fragment>
      <div className="box-sales mb20">
        <div className="title">{title}</div>
        <div className="box-sales__inner">
          <div
            className="price"
            style={isAggregate ? { fontSize: '20px' } : {}}
          >
            {isAggregate ? '集計中' : `${sales.toLocaleString('en-US')}円`}
          </div>
          {!isAggregate && (
            <div className="function">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  history.push(historyPath)
                }}
              >
                履歴
              </a>
            </div>
          )}
        </div>
      </div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <section className="modal" id="modal-door">
          <div className="modal-header">
            <div className="title">β版のため振込申請機能は準備中です</div>
            <div className="close modal-close">
              <span className="material-icons">
                <CancelIcon onClick={handleClose} />
              </span>
            </div>
          </div>
          <div className="modal-contents">
            <div className="text-center">
              <img src={YoorDoor1} />
            </div>
            <p className="mt1 mb10 text-center">
              正式リリースまで今しばらくお待ちください
            </p>
          </div>
        </section>
      </Dialog>
    </React.Fragment>
  )
}
